import {
  HddOutlined, MenuOutlined, SyncOutlined, TeamOutlined, ToTopOutlined, UserOutlined,
} from '@ant-design/icons';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import { EMITTER_CONSTANTS } from '../../constants';
import { logoutRequest } from '../../redux/actions/login';
import handleRefreshToken from '../../services/apollo/func/handle/handleRefreshToken';
import auth from '../../utils/auth';
import emitter from '../../utils/eventEmitter';
import MainDrawer from '../components/drawers/mainDrawer';
import MainHeader from '../components/mainHeader';
import LoadingPage from '../components/ui/loading';
import AdminRoute from './adminRoute';
import './style.scss';
import PowerUserRoute from './powerUserRoute';
import LightUserRoute from './lightUserRoute';

const esimAdminMenu = [
  {
    key: '0',
    icon: <SyncOutlined />,
    activeIcon: <SyncOutlined />,
    label: 'Reassign eID history',
    subLabel: '',
    ref: '/reassign-eid',
  },
  {
    key: '1',
    icon: <HddOutlined />,
    activeIcon: <HddOutlined />,
    label: 'Card\'s license and status',
    subLabel: '',
    ref: '/card-license',
  },
  {
    key: '2',
    icon: <TeamOutlined />,
    activeIcon: <TeamOutlined />,
    label: 'User management',
    subLabel: '',
    ref: '/user-management',
  },
  {
    key: '3',
    icon: <UserOutlined />,
    activeIcon: <UserOutlined />,
    label: 'Customer accounts',
    subLabel: '',
    ref: '/customer-accounts',
  },
];
const esimPowerUserMenu = [
  {
    key: '0',
    icon: <SyncOutlined />,
    activeIcon: <SyncOutlined />,
    label: 'Reassign eID history',
    subLabel: '',
    ref: '/reassign-eid',
  },
  {
    key: '1',
    icon: <HddOutlined />,
    activeIcon: <HddOutlined />,
    label: 'Card\'s license and status',
    subLabel: '',
    ref: '/card-license',
  },
];
const esimUserMenu = [
  {
    key: '0',
    icon: <SyncOutlined />,
    activeIcon: <SyncOutlined />,
    label: 'Reassign eID history',
    subLabel: '',
    ref: '/reassign-eid',
  },
];

const getMenuByRole = () => {
  if (auth.isAdmin()) return esimAdminMenu;
  if (auth.isPowerUser()) return esimPowerUserMenu;
  return esimUserMenu;
};
const getRouteByRole = () => {
  if (auth.isAdmin()) return <AdminRoute />;
  if (auth.isPowerUser()) return <PowerUserRoute />;
  return <LightUserRoute />;
};

const PrivateNavigation = () => {
  const menu = useMemo(() => getMenuByRole());

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedTab, setSelectedTab] = useState(menu[0]);

  const onChangeTab = (selected) => {
    history.push(selected.ref);
    setDrawerVisible(false);
  };

  const onToggleMenu = () => {
    setDrawerVisible(drawerVisible => !drawerVisible);
  };

  const onCloseDrawer = () => {
    setDrawerVisible(false);
  };

  const logout = () => {
    dispatch(logoutRequest());
    history.replace('/login');
  };

  useEffect(() => {
    const currentRoute = _.find(menu, x => location.pathname.includes(x.ref));
    setSelectedTab(currentRoute);
  }, [location.pathname]);

  useEffect(() => {
    emitter.addListener(EMITTER_CONSTANTS.LOGOUT_REQUEST, logout);
  }, [location.pathname]);

  useEffect(() => {
    // Access token now expires in 60m server-side; refresh well before that
    // so an active session keeps sliding, while an idle/stolen token still
    // dies within an hour.
    const REFRESH_INTERVAL_MS = 10 * 60 * 1000;
    const intervalId = setInterval(() => {
      handleRefreshToken().catch(() => {});
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="app">
      <div className="app-body">
        <main className="main">
          <Container fluid>
            <LoadingPage />
            <MainHeader
              icon={drawerVisible ? <ToTopOutlined style={{ transform: 'rotate(-90deg)' }} /> : <MenuOutlined />}
              onToggleMenu={onToggleMenu}
            />
            <div className="main-body">
              <MainDrawer
                menu={menu}
                visible={drawerVisible}
                activeKey={selectedTab?.key || '999'}
                onChangeTab={onChangeTab}
                onClose={onCloseDrawer}
              />
              {getRouteByRole()}
            </div>
          </Container>
        </main>
      </div>
    </div>
  );
};

PrivateNavigation.defaultProps = {

};

PrivateNavigation.propTypes = {
};


export default PrivateNavigation;
